import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/shareIcons/calendar.svg'
import _imports_1 from '@/assets/images/settings/bubble-checkmark.svg'
import _imports_2 from '@/assets/images/shareIcons/person.svg'


const _hoisted_1 = {
  class: "bg-modal w-maxC",
  style: {"padding":"0.3rem","min-width":"8rem"}
}
const _hoisted_2 = { class: "pad-s" }
const _hoisted_3 = { class: "row gap-05" }
const _hoisted_4 = { class: "item-l" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "item-l" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "item-l" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "row gap-03" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "colend" }

import DSP_ICON from '@/assets/images/myDsp.jpg';
import CVE_ICON from '@/assets/images/cve.png';
import MR_ICON from '@/assets/images/mr.svg';

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { formatMatricule } from '@/functions/lu';
import { toastSuccess } from '@/utils/toast-utils';
import { useToast } from "primevue";
import gen from "@/functions/general.js";
import { useRouter } from 'vue-router';
import { useUiStore } from '@/stores/ui';
import PersonService from "@/services/PersonService";

const DSP_URL = "https://www.esante.lu/dsp-ps/com/ideoApp.html?idOnglet=aa&vueParam=0#2019_12_17_02_30_8dd63255-9427-4a99-b712_RUB_IDENTIERECHERCHE_FILTRE/identity.CallIdentiteRecherche//base64:eyJ3ZWJDb250ZXh0Ijp7InZ1ZSI6IjAiLCJldGFibGlzc2VtZW50SWQiOjEsImlkV29ya2xpc3QiOiJJREVOVElURSJ9fQ==";
const CVE_URL = "https://www.esante.lu/cve/auth/health-professional-cas";
const MR_URL = "https://www.esante.lu/medecin-referent/";


export default /*@__PURE__*/_defineComponent({
  __name: 'patientActions',
  emits: ['close', 'addTask'],
  setup(__props, { emit: __emit }) {

const uiStore = useUiStore();
const router = useRouter();
const toast = useToast();
const { t } = useI18n();
const currentEntryStore = useCurrentEntryStore();
const emits = __emit;

const pwr = computed(() => {
  return currentEntryStore.showPatientModal
    ? currentEntryStore.modalPatient
    : currentEntryStore.currentPatient;
})

const matricule = computed(() => {
  return pwr.value?.cnsHealthInsurance?.cnsAffiliationNumber ? formatMatricule(pwr.value.cnsHealthInsurance.cnsAffiliationNumber) : "";
})

const patientFullName = computed(() => {
  return PersonService.formatName(pwr.value?.lastName, pwr.value.firstName);
})

const sortedPhones = computed(() => {
	return sortByPreferenceThenDate(pwr.value?.phones || [])
})

const sortedMails = computed(() => {
	return sortByPreferenceThenDate(pwr.value?.emails || [])
})

const sortedAddresses = computed(() => {
	return sortByPreferenceThenDate(pwr.value?.addresses || [])
})

function sortByPreferenceThenDate(array) {
	return array.sort((a, b) => {
		if (a.isPreferred && !b.isPreferred) return -1;
		if (!a.isPreferred && b.isPreferred) return 1;
		return new Date(a.created).getTime() - new Date(b.created).getTime();
	})
}

const sortedRelatives = computed(() =>
  (pwr.value?.relatives ?? []).toSorted((a, b) =>
    a.lastName.localeCompare(b.lastName) ||
    a.firstName.localeCompare(b.firstName)
  )
);

function accessCalendar() {
  currentEntryStore.setCurrentPatientCalendar(pwr.value);
  emits('close');
  currentEntryStore.closePatientModal();
  router.push({
    name: "calendar"
  });
}

function addTask() {
  emits('addTask');
  emits('close');
}

const esanteWindows: Record<string, Window | null> = {};
function openEsante(name: string, url: string) {
  const win = esanteWindows[name];
  if (win && !win.closed) {
    win.location.href = url;
    win.focus();
  } else {
    esanteWindows[name] = window.open(url, name);
  }
}

function openDsp() {
  openEsante("dsp-esante", DSP_URL);
}

function openCve() {
  openEsante("cve-esante", CVE_URL);
}

function openMr()  {
  openEsante("mr-esante",  MR_URL);
}

async function toClipboardWithToast(text: string) {
  try {
    await navigator.clipboard.writeText(text);
    toastSuccess(toast, {
      summary: t('patient.admin.cnsNumber.copied'),
      detail:  text
    });
  } catch (err) {
    console.error('Failed to copy text: ', err);
  }
}

function openMap(address) {
  const fullAddress = `${address.street}, ${address.postalCodePrefix || ''}${address.postalCode} ${address.locality}, ${address.country}`;
  const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress)}`;
  window.open(url, "_blank");
}

function sendEmail(email) {
  window.location.href = gen.getEmailUrl(email);
}

function callNumber(phone) {
  window.location.href = gen.getTelUrl(phone);
}

function contact(rawNumber) {
  if (rawNumber === '') return rawNumber
  return rawNumber.match(/.{1,3}/g).join(' ');
}

async function openPatientModal(pwrRelative: any) {
  const patientId = pwrRelative.personWithRoleId;
  emits('close');
  currentEntryStore.openPatientModal();
  await currentEntryStore.setModalPatient(patientId);
}

async function accessPatient(pwrRelative: any) {
  uiStore.setLoadingScreenText(PersonService.formatName(pwrRelative.lastName, pwrRelative.firstName));
  if (pwrRelative.personWithRoleId !== currentEntryStore.currentPatientId) {
    currentEntryStore.clearCurrentEntry();
  }
  emits('close');
  currentEntryStore.closePatientModal();
  router.push({
    name: 'patient',
    params: { patientId: pwrRelative.personWithRoleId },
  });
}


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dbGroup = _resolveComponent("dbGroup")!
  const _component_es_button_icon = _resolveComponent("es-button-icon")!
  const _component_listGroup = _resolveComponent("listGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_buttonGroup, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openDsp()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _unref(DSP_ICON),
                alt: "Logo",
                style: {"width":"100%","height":"100%"}
              }, null, 8, _hoisted_5)
            ]),
            _createVNode(_component_text_item, {
              txt: "DSP",
              class: "mleft-03"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_buttonGroup, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (openCve()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _unref(CVE_ICON),
                alt: "Logo",
                style: {"width":"100%","height":"100%"}
              }, null, 8, _hoisted_7)
            ]),
            _createVNode(_component_text_item, {
              txt: "CVE",
              class: "mleft-03"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_buttonGroup, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (openMr()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("img", {
                src: _unref(MR_ICON),
                alt: "Logo",
                style: {"width":"100%","height":"100%"}
              }, null, 8, _hoisted_9)
            ]),
            _createVNode(_component_text_item, {
              txt: "Médecin référent",
              class: "mleft-03"
            })
          ]),
          _: 1
        })
      ])
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "line-h mtop-03 mbottom-04" }, null, -1)),
    _createElementVNode("div", null, [
      _createVNode(_component_dbGroup, { class: "mtop-02" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_buttonGroup, {
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (toClipboardWithToast(`${patientFullName.value} ${matricule.value}`)), ["stop"])),
              class: "psides-04",
              styles: "pad-s"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "documents",
                  styles: "size-s"
                }),
                _createVNode(_component_text_item, {
                  txt: patientFullName.value,
                  class: "mleft-04"
                }, null, 8, ["txt"])
              ]),
              _: 1
            }),
            (matricule.value)
              ? (_openBlock(), _createBlock(_component_buttonGroup, {
                  key: 0,
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (toClipboardWithToast(matricule.value.replaceAll(' ', ''))), ["stop"])),
                  styles: "pad-s",
                  class: "psides-04"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_item, {
                      icon: "documents",
                      styles: "size-s"
                    }),
                    _createVNode(_component_text_item, {
                      txt: matricule.value,
                      class: "mleft-04"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_list_group, {
            class: "w-full",
            styles: "pad-m",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (accessCalendar()))
          }, {
            default: _withCtx(() => [
              _cache[7] || (_cache[7] = _createElementVNode("img", {
                src: _imports_0,
                class: "img-primary"
              }, null, -1)),
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.actionButton.accessCalendar'),
                class: "mleft-05 txt-primary font-size-14"
              }, null, 8, ["txt"])
            ]),
            _: 1
          }),
          _createVNode(_component_list_group, {
            class: "w-full",
            styles: "pad-m",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (addTask()))
          }, {
            default: _withCtx(() => [
              _cache[8] || (_cache[8] = _createElementVNode("img", {
                src: _imports_1,
                class: "img-primary"
              }, null, -1)),
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.actionButton.createTask'),
                class: "mleft-05 txt-primary font-size-14"
              }, null, 8, ["txt"])
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedPhones.value, (phone, indexPhone) => {
            return (_openBlock(), _createBlock(_component_list_group, {
              key: indexPhone,
              class: "w-full",
              styles: "pad-m",
              onClick: ($event: any) => (callNumber(phone))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "phone",
                  styles: "size-s",
                  style: {"margin-top":"-0.5rem"}
                }),
                _createVNode(_component_text_item, {
                  txt: '+' + phone.phonePrefix,
                  class: "mleft-05 main-m"
                }, null, 8, ["txt"]),
                _createVNode(_component_text_item, {
                  txt: contact(phone.phoneNumber),
                  class: "mleft-05"
                }, null, 8, ["txt"])
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedMails.value, (mail, indexMail) => {
            return (_openBlock(), _createBlock(_component_list_group, {
              key: indexMail,
              class: "w-full",
              styles: "pad-m",
              onClick: ($event: any) => (sendEmail(mail.email))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "mail",
                  styles: "size-s",
                  style: {"margin-top":"-0.5rem"}
                }),
                _createVNode(_component_text_item, {
                  txt: mail.email,
                  class: "mleft-05"
                }, null, 8, ["txt"])
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedAddresses.value, (address, indexAddress) => {
            return (_openBlock(), _createBlock(_component_list_group, {
              key: indexAddress,
              class: "w-full",
              styles: "pad-m",
              onClick: ($event: any) => (openMap(address))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "mapPin",
                  styles: "size-s",
                  style: {"margin-top":"-0.5rem"}
                }),
                _createVNode(_component_text_item, {
                  txt: `${address.street} ${address.postalCodePrefix}${address.postalCode} ${address.locality}`,
                  class: "mleft-05"
                }, null, 8, ["txt"])
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "line-h mtop-05 mbottom-05" }, null, -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedRelatives.value, (pwrRelative, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (pwrRelative.personRoleType === 'CustomPatient')
          ? (_openBlock(), _createBlock(_component_listGroup, {
              key: 0,
              styles: "pad-s"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "w-full row gap-06",
                  onClick: ($event: any) => (openPatientModal(pwrRelative))
                }, [
                  _cache[9] || (_cache[9] = _createElementVNode("img", { src: _imports_2 }, null, -1)),
                  _createVNode(_component_text_item, {
                    txt: _unref(PersonService).formatName(pwrRelative.lastName, pwrRelative.firstName)
                  }, null, 8, ["txt"]),
                  _createVNode(_component_text_item, {
                    txt: pwrRelative.relation.description,
                    styles: "main-m"
                  }, null, 8, ["txt"])
                ], 8, _hoisted_11),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_es_button_icon, {
                    styles: "img-grey square-16",
                    buttonStyles: "flex-square-29",
                    icon: "stethoscope",
                    folder: "shareIcons",
                    onClick: ($event: any) => (accessPatient(pwrRelative))
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})